import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * CR-20260927-002. The ONE workspace that hosts pinned panels (today: every TMHQ user's
 * Action Board) = the first workspace of the first layout tab, as the layout tabs are ordered
 * right now. The host owns the layouts, so the host computes it and publishes it here whenever
 * the layouts change; every workspace reads it to decide whether the pinned panel belongs to it.
 */
@Injectable({ providedIn: 'root' })
export class PinnedPanelsService {

   private readonly _designatedWorkspaceId = new BehaviorSubject<string | null>(null);
   private _actionBoardDismissed = false;

   get actionBoardDismissed(): boolean {
      return this._actionBoardDismissed;
   }

   dismissActionBoard(): void {
      this._actionBoardDismissed = true;
   }

   reopenActionBoard(): void {
      this._actionBoardDismissed = false;
   }

   resetSession(): void {
      this._actionBoardDismissed = false;
      this.setDesignatedWorkspace(null);
   }

   get designatedWorkspaceId(): string | null {
      return this._designatedWorkspaceId.value;
   }

   get designatedWorkspaceId$(): Observable<string | null> {
      return this._designatedWorkspaceId.asObservable();
   }

   setDesignatedWorkspace(workspaceId: string | null): void {
      if (this._designatedWorkspaceId.value === workspaceId) {
         return;
      }
      this._designatedWorkspaceId.next(workspaceId);
   }
}
